export default "__VITE_ASSET__BdCnt_GF__"